import React from 'react'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import style from './style'
import WiringPanel from 'components/WiringPanel'
import getCurrentCamera from 'helpers/cameras/getCurrentCamera'
import { connectedNetworkClosetSelector, cameraWireSelector, networkClosetExistsSelector, networkClosetsArraySelector } from 'selectors/components'

const mapStateToProps = state => {
  return {
    currentCamera: getCurrentCamera(state.cameras)
  }
}

class MobileWiringPanel extends React.Component {
  render() {
    const { currentCamera, highlightNetworkClosetListener, classes } = this.props

    if (!currentCamera) return null

    return (
      <div className={classes.wiringPanel}>
        <div className={classes.header}>
          Cabling
        </div>
        <div className={classes.body}>
          <WiringPanel
            startDevice={currentCamera}
            startDeviceType='camera'
            highlightNetworkClosetListener={highlightNetworkClosetListener}
            mobile
          />
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps)(injectSheet(style)(MobileWiringPanel))



// WEBPACK FOOTER //
// ./src/components/BottomBar/WiringPanel/index.js